<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import PracticeStaffAddEditForm from "@/components/models/practice/forms/PracticeStaffAddEditForm.vue";
import { useAbility } from "@casl/vue";
import { computed } from "vue";
import { usePracticeStaff } from "@/composables/models/practice/usePracticeStaff";
import { useRoute } from "vue-router";

const route = useRoute();
const routeParams = computed((): { id?: string } => route.params as { id?: string });

const practiceStaff = usePracticeStaff({ id: routeParams.value.id });
const backLink = computed(() => route.query.backLink as string);

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.staff" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.UPDATE, $permSubjects.PRACTICE__PRACTICESTAFF);
    },
  },
});
</script>

<template>
  <v-skeleton-loader :loading="practiceStaff.isLoading.value">
    <PracticeStaffAddEditForm
      :practiceStaff="practiceStaff.data.value"
      :backLink="backLink"
    />
  </v-skeleton-loader>
</template>
